module.exports = __webpack_public_path__ + "img/logo.512ce46f.svg";